export enum TravelPlanBenefitsTab {
    Benefits="Benefits",
    Pricing="Pricing"
}